import api from './api';
import { Coupon, CreateCouponRequest } from '../types';

interface CouponResponse {
  coupons: Coupon[];
  total: number;
}

export const couponService = {
  async getAllCoupons(filters?: {
    number?: string;
    campaignId?: string;
    storeId?: string;
    sellerName?: string;
    userName?: string;
    status?: string;
    page?: number;
    limit?: number;
  }): Promise<{ coupons: Coupon[]; total: number }> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });
    }
    const response = await api.get(`/coupons?${params.toString()}`);
    return response.data;
  },

  async getMyCoupons(filters?: {
    number?: string;
    campaignId?: string;
    storeId?: string;
    sellerName?: string;
    status?: string;
    page?: number;
    limit?: number;
    activeCampaignsOnly?: boolean;
  }): Promise<CouponResponse> {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined) {
          params.append(key, value.toString());
        }
      });
    }
    const response = await api.get(`/coupons/my?${params.toString()}`);
    return response.data;
  },

  async getCouponById(id: string): Promise<Coupon> {
    const response = await api.get(`/coupons/${id}`);
    return response.data;
  },

  async createCoupon(coupon: CreateCouponRequest): Promise<Coupon> {
    const response = await api.post('/coupons', coupon);
    return response.data;
  },

  async deleteCoupon(id: string): Promise<void> {
    await api.delete(`/coupons/${id}`);
  },

  async deleteMyCoupon(id: string): Promise<void> {
    await api.delete(`/coupons/my/${id}`);
  },

  getMyCouponById: async (id: string): Promise<Coupon> => {
    const response = await api.get(`/coupons/my/${id}`);
    return response.data;
  },

  updateMyCoupon: async (id: string, data: { number: number; sellerName?: string }): Promise<Coupon> => {
    const response = await api.put(`/coupons/my/${id}`, data);
    return response.data;
  },

  async getCouponsByCampaign(campaignId: string): Promise<Coupon[]> {
    const response = await api.get(`/coupons/campaign/${campaignId}`);
    return response.data;
  },

  async getCouponsByUser(userId: string): Promise<Coupon[]> {
    const response = await api.get(`/coupons/user/${userId}`);
    return response.data;
  },

  async validateCoupon(code: string): Promise<Coupon> {
    const response = await api.post('/coupons/validate', { code });
    return response.data;
  }
}; 